module.exports = __webpack_public_path__ + "static/media/massawa.726e1d45.jpg";